import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

function renderInput(inputProps) {
  const { classes, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: ref,
        classes: {
          input: classes.input,
        },
        ...other,
      }}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </strong>
          );
        })}
      </div>
    </MenuItem>
  );
}

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

const styles = theme => ({
  container: {
    flexGrow: 5,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

class IntegrationAutosuggest extends React.Component {
  state = {
    value: '',
    suggestions: [],
  };

  componentDidMount() {
    const {defaultValue} = this.props
    if (defaultValue)
      this.setState({value: defaultValue})
  }

  handleSuggestionsFetchRequested = async ({ value, reason }) => {
    if (reason !== 'input-changed') {
        return;
    }
    const { getSuggestions } = this.props;
    const newSuggestions = await getSuggestions(value)
    this.setState({
      suggestions: newSuggestions,
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  doSearch = (value) => {
    const { parentSearchChangeHandler } = this.props
    parentSearchChangeHandler(value)
  }

  doChange = (value) => {
    const {parentOnChangeHandler = (v)=>{}} = this.props
    parentOnChangeHandler(value)
  }

  handleChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue,
    });
    //console.log('changed search input: ' + method + ' to ' + newValue)
    this.doChange(newValue)
    if (method == 'enter' || method == 'click') {
      this.doSearch(newValue)
    }
  };

  handleKeyDown = (event) => {
    if (event.nativeEvent.keyCode === 13) {
      // ENTER was pressed
      this.doSearch(this.state.value)
    }
  }

  render() {
    const { classes, label='Поиск', placeholder='Начните набирать...' } = this.props;

    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={{
          classes,
          label: label,
          placeholder: placeholder,
          value: this.state.value,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyDown,
          type: 'search',
          className: classes.textField,
        }}
      />
    );
  }
}

IntegrationAutosuggest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntegrationAutosuggest);



// WEBPACK FOOTER //
// ./src/TypeAheadComponent.js